import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

interface IButton {
  color: "error" | "success" | "warning" | "info" | "primary" | "secondary";
  label: string;
  callback: () => void;
}

interface IErrorMsgProps {
  title: string;
  msg: string | JSX.Element;
  buttons?: IButton[];
}

/**
 * AlertDialog
 * @param title -
 * @param msg -
 * @param buttons - Optional, defaults to error message when no buttons are passed.
 * @returns A MUI display with a title, message, and cooresponsing buttons
 */
export const AlertDialog = (props: IErrorMsgProps): JSX.Element => {
  const title = props?.title ? props.title : "Connection Error";
  const message = props?.msg
    ? props.msg
    : "There was a connection issue, if the problem persists please contact support.";
  const buttons: IButton[] = props?.buttons?.length
    ? [...props.buttons, { color: "error", label: "Refresh", callback: () => window.location.reload() }]
    : [{ color: "error", label: "Refresh", callback: () => window.location.reload() }];

  return (
    <Dialog
      disableEscapeKeyDown={true}
      open={true}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {buttons?.map((button, index) => (
          <Button key={index} variant="contained" color={button.color} onClick={button.callback}>
            {button.label}
          </Button>
        ))}
      </DialogActions>
    </Dialog>
  );
};
